<template>
  <div class="sell-control-container">
    <div class="content-wrapper" v-show="!showDetailModal">
      <!-- 下拉控制按钮 -->
      <div class="pull-handle" @click="togglePanel">
        <div class="pull-handle-icon" :class="{ 'rotate-icon': !panelOpen }"></div>
      </div>
    <div class="sell-control-panel" :class="{ 'panel-open': panelOpen }">
      <!-- 状态图例 -->
      <div class="status-legend">
        <div class="legend-item">
          <span class="legend-color" style="background-color: rgba(158, 226, 255, 0.6)"></span>
          <span>在售</span>
        </div>
        <div class="legend-item">
          <span class="legend-color" style="background-color: rgba(216, 216, 216, 0.58)"></span>
          <span>已售/待售</span>
        </div>
        <div class="legend-item">
          <span class="legend-color" style="background-color: rgba(244, 172, 221, 0.6)"></span>
          <span>优惠房源</span>
        </div>
      </div>
      <!-- Tab 栏 -->
      <div class="building-tabs">
        <!-- 左侧固定按钮 -->
        <div class="tab-item all-buildings" @click="showAllBuildings">
          <span class="back-icon">←</span>
          <span style="color: #1890ff">全部楼栋</span>
        </div>

        <!-- 右侧可滚动区域 -->
        <div class="scrollable-tabs">
          <div
              v-for="building in buildingList"
              :key="building.buildingId"
              class="tab-item"
              :class="{ 'active': activeBuildingId === building.buildingId }"
              @click="changeBuilding(building)"
          >
            {{ building.buildingNumber }}号楼
          </div>
        </div>
      </div>
      <a-table
          :columns="columns"
          :data-source="tableData"
          :row-key="record => record.floor"
          bordered
          size="small"
          :pagination="false"
          :scroll="{ x: 'max-content', y: 'calc(78vh - 150px)' }"
      >
        <!-- 房屋信息列 -->
        <template v-for="col in columns" #[col.dataIndex]="{ record }" :key="col.key">
          <div
              v-if="col.dataIndex !== 'floor' && record[col.dataIndex]"
              class="mobile-cell"
              :data-sold="record[col.dataIndex].sold"
              :discounted-housing="record[col.dataIndex].discountedHousing"
              @click="showRoomDetail(record, col.dataIndex)"
          >
            <div class="mobile-cell-title">{{ record[col.dataIndex].floorNumber }}</div>
            <div class="mobile-cell-content">
              <div class="mobile-cell-item">
                <span >{{ record[col.dataIndex].floorSpace!==''?record[col.dataIndex].floorSpace:' -- ' }} ㎡</span>
              </div>
              <div class="mobile-cell-item">
                <span>{{ record[col.dataIndex].unitPrice!==''?record[col.dataIndex].unitPrice:' -- ' }} 元/㎡</span>
              </div>
              <div class="mobile-cell-item">
                <span>￥{{ record[col.dataIndex].totalPrice!==''?record[col.dataIndex].totalPrice:' -- ' }} 万元</span>
              </div>
            </div>
          </div>
          <div v-else-if="col.dataIndex === 'floor'">
            <div class="floor-cell">
              {{ record.floor }}层
            </div>
          </div>
        </template>
      </a-table>
    </div>
    </div>

    <!-- 添加底部弹窗 -->
    <div class="room-detail-modal" :class="{ 'modal-open': showDetailModal }">
      <div class="modal-content">
        <div class="modal-header">
          <div class="room-title">
            {{ selectedRoom.buildingNumber }}栋{{ selectedRoom.unit }}单元{{ selectedRoom.floor }}层{{ selectedRoom.room }}号
          </div>
          <button class="close-btn" @click="closeDetailModal">返回全部房间</button>
        </div>
        <div class="room-info">
          <div class="info-block">
            <div class="info-value">{{ selectedRoom.floorSpace || '--' }} ㎡</div>
            <div class="info-label">面积</div>
          </div>
          <div class="info-block">
            <div class="info-value" style=" font-weight: bold;color: #ee3333">￥{{ selectedRoom.totalPrice || '--' }} 万元</div>
            <div class="info-label">总价</div>
          </div>
          <div class="info-block">
            <div class="info-value" style=" font-weight: bold;color: #ee3333">{{ selectedRoom.unitPrice || '--' }} 元/㎡</div>
            <div class="info-label">单价</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed, defineExpose} from 'vue'
import { getByBuildingId } from '@/utils/sellControlTableApi'
import { getHouseFloors } from '@/utils/floors'

const props = defineProps({
  buildingInfo: {
    type: Object,
    default: () => ({})
  }
})
// 当前选中的建筑ID
const activeBuildingId = ref(null)
// 当前选中的建筑信息
const currentBuilding = ref(null)
// 楼栋号对应楼栋信息map
const buildingNumberMap = ref(null)

const buildingList = computed(() => {
  const list = Array.isArray(props.buildingInfo) ? [...props.buildingInfo] : []
  return list.sort((a, b) => a.buildingNumber - b.buildingNumber)
})


// 切换建筑
const changeBuilding = (building) => {
  activeBuildingId.value = building.buildingId
  currentBuilding.value = building
  generateTableStructure()
  emit('switchBuild',{
    buildingNumber: building.buildingNumber
  })
}

const renderChangeBuilding = (buildingNumber) => {
  const building = buildingNumberMap.value[buildingNumber]
  if (building) {
    activeBuildingId.value = building.buildingId
    currentBuilding.value = building
    generateTableStructure()
  }
}

// 弹窗相关状态
const showDetailModal = ref(false)
const selectedRoom = ref({
  buildingNumber: '',
  unit: '',
  floor: '',
  room: '',
  floorSpace: '',
  totalPrice: '',
  unitPrice: ''
})

const emit = defineEmits(['cancel', 'update:visible'])

// 使用内部状态管理抽屉显示，与外部props同步
const panelOpen = ref(false)
const togglePanel = () => {
  panelOpen.value = !panelOpen.value
  // if (!panelOpen.value) {
  //   emit('cancel')
  // } else {
  //   emit('update:visible', true)
  // }
  emit('handleDrawer', panelOpen.value)
}

const columns = ref([])
const tableData = ref([])

// 生成表结构
const generateTableStructure = () => {
  generateColumns()
  generateTableData()
}

// 生成表头
// 生成表头
const generateColumns = () => {
  const baseColumns = [{
    title: '楼层',
    dataIndex: 'floor',
    key: 'floor',
    width: 60,
    fixed: 'left',
    slots: { customRender: 'floor' },
    customHeaderCell: () => ({
      style: {
        'background-color': '#1890ff',
        'color': 'white',
        'font-weight': 'bold',
        'text-align': 'center'
      }
    })
  }]

  // 按单元和户号分组
  const unitRooms = {}
  currentBuilding.value?.houseList?.forEach(house => {
    if (!unitRooms[house.unit]) {
      unitRooms[house.unit] = []
    }
    unitRooms[house.unit].push(house.room)
  })

  // 生成列
  Object.keys(unitRooms).sort().forEach(unit => {
    unitRooms[unit].sort().forEach((room, index) => {
      const roomData = {
        title: `${unit}单元`,
        dataIndex: `u${unit}r${room}`,
        key: `u${unit}r${room}`,
        colSpan: 0,
        customHeaderCell: () => ({
          style: {
            'font-weight': 'bold',
            'text-align': 'center'
          }
        })
      }
      if (index === 0) {
        roomData.colSpan = 2
      }
      baseColumns.push(roomData)
    })
  })
  baseColumns.slice(1).forEach(col => {
    col.slots = { customRender: col.dataIndex }
  })

  columns.value = baseColumns
}

// 生成表格数据
const generateTableData = async () => {
  const data = []
  const totalFloors = currentBuilding.value.totalFloor
  const buildingId = currentBuilding.value.buildingId

  tableData.value = []
  try {
    // TODO 如果返回的数据为空，需要正确处理表格数据生成内容
    const response = await getByBuildingId(buildingId)
    if (response.data.code === 200) {
      // 创建楼层数据映射
      const responseDataMap = {}
      response.data.result?.forEach(item => {
        const key = `${item.floor}_${item.unit}_${item.room}`
        responseDataMap[key] = {
          unitPrice: item.unitPrice,
          totalPrice: item.totalPrice,
          sold: item.soldStatus,
          floorSpace: item.floorSpace,
          discountedHousing: item.discountedHousing
        }
      })

      // 从顶层开始生成每层数据；单元层数各不相同时，超出该单元层数的格子不生成（不显示）
      for (let floor = totalFloors; floor >= 1; floor--) {
        const rowData = { floor }
        let hasAnyRoom = false
        currentBuilding.value.houseList?.forEach(area => {
          if (floor > getHouseFloors(area, currentBuilding.value)) {
            return
          }
          hasAnyRoom = true
          const key = `u${area.unit}r${area.room}`
          const responseKey = `${floor}_${area.unit}_${area.room}`
          rowData[key] = {
            floorSpace: responseDataMap[responseKey]?.floorSpace || '',
            floorNumber: `${floor}0${area.room}`,
            discountedHousing: responseDataMap[responseKey]?.discountedHousing || 0,
            unitPrice: responseDataMap[responseKey]?.unitPrice || '',
            totalPrice: responseDataMap[responseKey]?.totalPrice || '',
            sold: responseDataMap[responseKey]?.sold === undefined ? 1 : responseDataMap[responseKey].sold
          }
        })
        // 该层所有单元都不存在时（各单元层数都比楼栋矮），整行没必要占位
        if (hasAnyRoom) {
          data.push(rowData)
        }
      }
      tableData.value = data
    } else {
      console.error('获取销控表数据失败')
    }
  } catch (error) {
    console.error('获取销控表数据出错:', error)
  }
}

// 显示房间详情
const showRoomDetail = (record, dataIndex) => {
  // 从dataIndex解析单元和房号 (格式如: u1r101)
  const matches = dataIndex.match(/u(\d+)r(\d+)/)
  if (matches) {
    selectedRoom.value = {
      buildingNumber: currentBuilding.value.buildingNumber,
      unit: matches[1],
      floor: record.floor,
      room: matches[2],
      floorSpace: record[dataIndex].floorSpace,
      totalPrice: record[dataIndex].totalPrice,
      unitPrice: record[dataIndex].unitPrice
    }
    const roomKey = `${currentBuilding.value.buildingNumber}_${matches[1]}_${record.floor}_${matches[2]}`
    emit('roomDetail', roomKey, 'table')
    showDetailModal.value = true
  }
}

const showRoomDetailBy3D = (unit, floor, room, record) => {
  // 从dataIndex解析单元和房号 (格式如: u1r101)
  selectedRoom.value = {
    buildingNumber: currentBuilding.value.buildingNumber,
    unit: unit,
    floor: floor,
    room: room,
    floorSpace: record[0]?.floorSpace,
    totalPrice: record[0]?.totalPrice,
    unitPrice: record[0]?.unitPrice
  }
  showDetailModal.value = true
}

// 关闭详情弹窗
const closeDetailModal = () => {
  showDetailModal.value = false
}

const showAllBuildings = () => {
  emit('showAllBuild')
}

// 监听buildingInfo变化
watch(buildingList, (newVal) => {
  if (newVal.length > 0 && !activeBuildingId.value) {
    changeBuilding(newVal[0])
  }
  buildingNumberMap.value = {}
  newVal.forEach(item => {
    if (item.houseList.length > 0) {
      buildingNumberMap.value[item.buildingNumber] = item
    }
  })
}, { immediate: true })

defineExpose({
  renderChangeBuilding,
  togglePanel,
  showRoomDetailBy3D
})
</script>

<style scoped>
/* ================= 基础容器样式 ================= */
.sell-control-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1001;
}

/* ================= 下拉控制按钮样式 ================= */
.pull-handle {
  height: 25px;
  background: #FFFFFF;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 120px; /* 新增：固定宽度 */
  margin: 0 auto; /* 新增：水平居中 */
}
.pull-handle-icon {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #000000;
  transition: transform 0.3s ease;
}

.rotate-icon {
  transform: rotate(180deg);
}

/* ================= 主面板样式 ================= */
.sell-control-panel {
  height: 27vh;
  overflow: hidden;
  transition: height 0.3s ease;
  background: white;
  padding: 0 8px;
  margin: 0 8px;
  border-radius: 12px 12px 0 0;
}

.sell-control-panel.panel-open {
  height: 80vh;
}

/* ================= Tab栏样式 ================= */
.building-tabs {
  display: flex;
  padding: 8px 12px;
  background: #ffffff;
  border-bottom: 1px solid #e4e7ed;
}

.scrollable-tabs {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scrollable-tabs::-webkit-scrollbar {
  display: none;
}

.tab-item {
  padding: 8px 20px;
  margin-right: 12px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  background: #fff;
  border: 1px solid #e4e7ed;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tab-item.all-buildings {
  background: #ffffff;
  border-color: #d9d9d9;
  display: flex;
  align-items: center;
}
.tab-item:hover {
  color: #1890ff;
  border-color: #a0cfff;
}

.tab-item.active {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
  font-weight: 500;
}

.back-icon {
  margin-right: 6px;
  font-weight: bold;
}

/* ================= 状态图例样式 ================= */
.status-legend {
  display: flex;
  gap: 16px;
  margin: 12px 0;
  padding: 8px;
  border-radius: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.legend-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #d9d9d9;
}

/* ================= 表格单元格样式 ================= */
.floor-cell {
  font-weight: bold;
  text-align: center;
  padding: 8px;
}

.mobile-cell {
  padding: 0 8px;
  display: flex;
  flex-direction: column;
}

.mobile-cell[data-sold="0"] {
  background-color: rgba(158, 226, 255, 0.6);
}
.mobile-cell[data-sold="1"] {
  background-color: rgba(204, 204, 204, 0.58);
}
.mobile-cell[discounted-housing="1"][data-sold="0"] {
  background-color: rgba(244, 172, 221, 0.6);
}

.mobile-cell-title {
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}

.mobile-cell-content {
  display: flex;
  flex-direction: column;
}

.mobile-cell-item {
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: center;
}

/* 单价样式 - 蓝色 */
.mobile-cell-item:nth-child(2) span {
  color: #1890ff;
}

/* 总价样式 - 淡橘黄色且字体稍大 */
.mobile-cell-item:nth-child(3) span {
  color: #f69c56;
  font-size: 15px;
  font-weight: 500;
}

/* ================= 房间详情弹窗样式 ================= */
.room-detail-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  z-index: 1002;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 0 0;
  padding: 16px;
}

.room-detail-modal.modal-open {
  transform: translateY(0);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.room-title {
  font-size: 16px;
  font-weight: bold;
}

.close-btn {
  background: #1890ff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.room-info {
  display: flex;
  justify-content: space-between;
}

.info-block {
  background: rgba(241, 240, 240, 0.47);
  border-radius: 12px;
  flex: 1;
  text-align: center;
  padding: 8px 0;
  margin: 0 3px;
}

.info-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
}

/* ================= Ant Design 表格覆盖样式 ================= */
:deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  padding: 8px !important;
}

:deep(.ant-table-tbody > tr > td) {
  padding: 0 !important;
}
</style>